import React, { Component } from 'react';

class NowPlaying extends Component {
  render() {
    return (
      <div className="NowPlaying">
        <h1>Now Playing</h1>
        <h2>{ this.props.track.title }</h2>
        <h3>{ this.props.track.artist }</h3>
      </div>
    );
  }
}

export default NowPlaying;



// WEBPACK FOOTER //
// ./src/NowPlaying.js